import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { FinancialPerformanceApi } from '../financialPerformance.api';

export const useGetPerformanceSolvency = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: FinancialPerformanceApi.getCalculationsOfPerformanceSolvency,
  });
};
